<template>
	<div class="ap-wrap-content">
		<div class="ap-wrap-header">
			<Header />
		</div>
		<div class="ap-scroll-view">
			<transition name="fade" mode="out-in">
				<router-view />
			</transition>
			<!-- <Footer v-if="!mobile" /> -->
			<Footer />
		</div>
	</div>
</template>

<script>
import Header from './components/Header';
import Footer from './components/Footer';
export default {
	name: 'App',
	components: {
		Header,
		Footer,
	},
	data() {
		return {
			mobile: this.isMobile(),
		};
	},
	methods: {
		isMobile() {
			try {
				document.createEvent('TouchEvent');
				return true;
			} catch (e) {
				return false;
			}
		},
	},
};
</script>

<style scoped>
.ap-wrap-content {
	width: 100%;
	height: 100%;
	overflow: hidden;
	position: relative;
}

.ap-wrap-header {
	position: absolute;
	top: 0px;
	left: 0px;
	z-index: 10;
}

.ap-scroll-view {
	width: 100%;
	height: 100%;
	overflow-y: auto;
	overflow-x: hidden;
	scroll-behavior: smooth !important;
	z-index: 2;
}

/* Transition style */
.fade-enter-active,
.fade-leave-active {
	transition-duration: 0.2s;
	transition-property: opacity;
	transition-timing-function: ease-in;
}

/* Transition style */
.fade-enter,
.fade-leave-active {
	opacity: 0;
}
</style>

<style>
* {
	hyphens: auto;
}

a {
	scroll-margin-top: 10px;
}
/* Global color styles */
:root {
	--main-color-highlight: #ffe100;
	--secondary-color-highlight: #e7d96f;
	--main-color-darker: #1d1e2e;
	--main-color-dark: #202240;
	--main-color-medium: #454764;
	--main-color-light: #50526c;
	--main-color-bg: #ffffff;
	--main-color-text-dark: #000000;
	--main-color-text-light: #ffffff;
	--main-color-button: #ffffff;
	--main-color-button-border: #000000;
	--main-color-selection: rgba(255, 235, 53, 0.5);
	--main-color-border-light: #ffffff;
	--main-color-border-dark: #000000;

	--main-color-success: #00bb09;
	--secondary-color-success: #00bb09aa;
	--main-color-warning: #f17c0d;
	--secondary-color-warning: #f17c0daa;
	--main-color-error: #fd0000;
	--secondary-color-error: #fd0000aa;
	--main-color-disabled: #aaaaaa;
}

body {
	background-color: #183d43;
	overflow: hidden;
	padding: 0px;
	margin: 0px;
}

html {
	scroll-behavior: smooth;
}

/* Global scrollbar style */
::-webkit-scrollbar {
	width: 14px;
	box-sizing: border-box;
}

/* Global scrollbar track style */
::-webkit-scrollbar-track {
	box-shadow: inset 0 0 5px black;
	border-radius: 10px;
}

/* Global scrollbar thumb style */
::-webkit-scrollbar-thumb {
	background: var(--main-color-highlight);
	border-radius: 10px;
	border: 1px solid black;
}

/* Global scrollbar corner style */
::-webkit-scrollbar-corner {
	background-color: var(--main-color-medium);
}

button {
	outline: none !important;
	box-shadow: none !important;
	background-color: var(--main-color-button);
	border: 2px solid var(--main-color-button-border);
	border-radius: 10px;
	color: var(--main-color-text-dark);
	cursor: pointer;
}
</style>
